/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCards = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 5v8h-6v6H2V5zM8 13H4v4h4zm6 0h-4v4h4zM8 7H4v4h4zm6 0h-4v4h4zm6 0h-4v4h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCards as Cards };
